import React from "react";
import {UserProvider} from "./component/context/UserContext";

import {RouterProvider} from "react-router-dom";
import router from "./component/routes/Router";
import history from "./component/routes/history";

import CSPMetaTag from "./component/_CSPMetaTag";

const cspConfig = {
    "default-src": ["'self'"],
    "script-src": ["'self'", "'unsafe-inline'", "https://app.usercentrics.eu", "https://api.usercentrics.eu", "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js", "http://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js"],
    "style-src": ["'self'", "https://fonts.googleapis.com"],
    "object-src": ["'none'"],
    "base-uri": ["'self'"],
    "connect-src": ["'self'", "https://aggregator.service.usercentrics.eu", "https://api.usercentrics.eu", "https://mxp.preprod.vertuelle.com"],
    "font-src": ["'self'", "https://fonts.gstatic.com"],
    "frame-src": ["'self'","https://www.google.com"],
    "img-src": ["'self'", "data:", "https://app.usercentrics.eu"],
    "style-src-elem" : ["'unsafe-inline'", "'self'", "https://fonts.googleapis.com", "https://www.google.com", "https://www.gstatic.com"],
    "manifest-src": ["'self'"],
    "media-src": ["'self'"],
    "worker-src": ["'none'"],
};

function App() {

    return (
        <>
            {/*<CSPMetaTag cspConfig={cspConfig}/>*/}
            <UserProvider>
                <RouterProvider router={router} history={history}/>
            </UserProvider>
        </>
    );
}

export default App;
